

import { form20DataInfoType } from '@/types/Information/Form20';
import { partiesDataJsonDataType } from '@/types/Information/json';
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form20";
const form20State = namespace("Form20");

@Component
export default class Form20StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @informationState.State
    public fileNumber: string;

    @form20State.State
    public form20Info: form20DataInfoType;

    @form20State.Action
    public UpdateForm20Info!: (newForm20Info: form20DataInfoType) => void  
    
    @form20State.State
    public currentNoticeOfObjectionToWithdrawalId: string;

    @form20State.Action
    public UpdateCurrentNoticeOfObjectionToWithdrawalId!: (newCurrentNoticeOfObjectionToWithdrawalId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    partyNames: string[] = [];
       

    lawyerNameOptions: string[] = [];

    state = {
        firstAppellant: null,
        firstRespondent: null,        
        withdrawingLawyerName: null, 
        withdrawingLawyerNameOther: null, 
        objectingParties: null,
        objectingPartiesOther: null,
        authorizedName:null
    }

    mounted() {
        this.dataReady = false;
        this.extractInfo();
        this.dataReady = true;              
    }

    public extractInfo(){     

        if(this.currentNoticeOfObjectionToWithdrawalId){
            this.getForm20Data();
           
        } else {  
            const form20Data = {} as form20DataInfoType;                  

            form20Data.appellants = this.partiesJson.appellants
            form20Data.respondents = this.partiesJson.respondents;
            form20Data.formSevenNumber = this.fileNumber;
            form20Data.version = this.$store.state.Application.version; 
            form20Data.objectingParties = [];
                  
            this.UpdateForm20Info(form20Data);            
            this.saveForm(true);                  
            
        }       

    }

    public extractPartiesData(){

        this.applicantNames = [];
        this.respondentNames = [];
        this.partyNames = [];
        this.lawyerNameOptions = [];

        for (const respondent of this.form20Info.respondents){
            this.respondentNames.push(respondent.name);
            this.partyNames.push(respondent.name);
            if (respondent.solicitor){

                const lawyerName = 
                    Vue.filter('getFullName')(respondent.solicitor.counselFirstName, respondent.solicitor.counselLastName)+
                    (respondent.solicitor.firmName? " ("+respondent.solicitor.firmName+")":"");

                if (!this.lawyerNameOptions.includes(lawyerName)){
                    this.lawyerNameOptions.push(lawyerName);
                }
                
            }
        }

        for (const applicant of this.form20Info.appellants){
            this.applicantNames.push(applicant.name);
            this.partyNames.push(applicant.name)  
            if (applicant.solicitor){

                const lawyerName = 
                    Vue.filter('getFullName')(applicant.solicitor.counselFirstName, applicant.solicitor.counselLastName)+
                    (applicant.solicitor.firmName? " ("+applicant.solicitor.firmName+")":"");
                
                if (!this.lawyerNameOptions.includes(lawyerName)){
                    this.lawyerNameOptions.push(lawyerName);
                }
            }         
        }
        this.lawyerNameOptions.push('Other')
        this.partyNames.push('Other')
        this.dataReady = true;

    }  

    public getForm20Data() {        
       
        this.$http.get('/form20/forms/'+this.currentNoticeOfObjectionToWithdrawalId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form20Data = response.data.data                
                this.UpdateForm20Info(form20Data) 
                this.extractPartiesData();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }   

    public clearStates(){
        this.state = {
            firstAppellant: null,
            firstRespondent: null,        
            withdrawingLawyerName: null, 
            withdrawingLawyerNameOther: null, 
            objectingParties: null,
            objectingPartiesOther: null,
            authorizedName:null
        }
        this.dataReady = true; 
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){        
        
        this.state.firstAppellant = !this.form20Info.firstAppellant? false : null;
        this.state.firstRespondent = !this.form20Info.firstRespondent? false : null;

        this.state.withdrawingLawyerName = !this.form20Info.withdrawingLawyerName? false : null; 
        if (this.form20Info.withdrawingLawyerName == 'Other'){
            this.state.withdrawingLawyerNameOther = !this.form20Info.withdrawingLawyerNameOther? false : null; 
        } else {
            this.state.withdrawingLawyerNameOther = null;
        }

        this.state.objectingParties = (this.form20Info.objectingParties.length == 0)? false : null; 
        if (this.form20Info.objectingParties.includes('Other')){
            this.state.objectingPartiesOther = !this.form20Info.objectingPartiesOther? false : null; 
        } else {
            this.state.objectingPartiesOther = null;
        }       
           
        this.state.authorizedName = !this.form20Info.authorizedName? false : null;       
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    }    

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form20/forms';

        if (this.currentNoticeOfObjectionToWithdrawalId){
            method = 'put';
            url = '/form20/forms/'+this.currentNoticeOfObjectionToWithdrawalId;               

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form20Info,
                    type:'Form20',
                    description:'Notice of Objection to Withdrawal'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form20Info,
                    type:'Form20',
                    description:'Notice of Objection to Withdrawal'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentNoticeOfObjectionToWithdrawalId(response.data.file_id);
                        this.extractPartiesData();                        
                    }

                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }   

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form20"}) 
    }

}
